__turbopack_context__.v({
  "className": "geistsans_9fc57718-module__5N2VMq__className",
  "variable": "geistsans_9fc57718-module__5N2VMq__variable",
});
